<template>
  <div class="display-menu">
    <section class="top-wrap">
      <div class="main-title">菜单设置</div>
      <div class="right">
        <dropdown-menu @click="clickBtn" width="120" :menu-list="operations" placement="bottom-end">
          <base-button>
            新建
          </base-button>
        </dropdown-menu>
        <base-button class="save" type="primary" @click="updateGroup">
          保存
        </base-button>
      </div>
    </section>
    <div v-if="!showMenuList" v-loading="!showMenuList" class="empty"></div>
    <section v-else class="content-box">
      <section class="menu-list-wrap no-bar">
        <div class="list-title">菜单</div>
        <div v-if="group.length == 0" class="group-empty">暂无菜单</div>
        <template v-else>
          <div class="group-box" :key="todoGroup.id">
            <menu-item
              type="todo"
              :data="todoGroup"
              :deletable="false"
              collapsed
              @collapse="collapseTodo"
              :fold="todoFold"
              visibleSetting
              :visible="todoVisible"
              @hide="hideTodo"
            ></menu-item>
            <template v-if="!todoFold">
              <menu-item
                v-for="item in todoGroup.itemList"
                type="todoItem"
                :data="item"
                :key="item.id"
                class="sheet-row"
                :deletable="false"
              ></menu-item>
            </template>
          </div>
          <draggable group="group" v-model="group" :animation="100">
            <div v-for="(groupInfo, groupIndex) in group" :key="groupInfo.id" class="group-box">
              <menu-item
                type="group"
                :data="groupInfo"
                @delete="deleteGroup(groupInfo, groupIndex)"
                editable
                can-add-sub-group
                collapsed
                @collapse="collapse(groupInfo.id)"
                @addSubGroup="addSubGroup(groupIndex)"
                :fold="fold[groupInfo.id]"
                @dragenter.native="changeFold(groupInfo.id)"
              ></menu-item>
              <draggable
                v-if="!fold[groupInfo.id]"
                group="group-item"
                v-model="groupInfo.itemList"
                :animation="100"
                @start="start($event, groupInfo)"
              >
                <div v-for="(item, itemIndex) in groupInfo.itemList" :key="item.id">
                  <menu-item
                    v-if="item.type !== 'GROUP'"
                    type="item"
                    from="group"
                    :data="item"
                    :editable="item.type === 'URL'"
                    @editUrl="editUrl('group', item, groupIndex)"
                    @delete="removeItem(groupInfo, item, itemIndex)"
                    class="sheet-row"
                  ></menu-item>
                  <template v-else>
                    <menu-item
                      type="subGroup"
                      :data="item"
                      @delete="removeItem(groupInfo, item, itemIndex)"
                      editable
                      collapsed
                      @collapse="collapse(item.id)"
                      :fold="fold[item.id]"
                      @dragenter.native="changeFold(item.id)"
                      class="sub-group"
                    ></menu-item>
                    <draggable
                      v-if="!fold[item.id]"
                      :group="{
                        name: 'group-item',
                        put: getPut
                      }"
                      v-model="item.itemList"
                      :animation="100"
                      class="sub-group"
                    >
                      <div v-for="(subItem, subItemIndex) in item.itemList" :key="subItem.id">
                        <menu-item
                          type="subItem"
                          from="group"
                          :data="subItem"
                          :editable="subItem.type === 'URL'"
                          @editUrl="editUrl('subGroup', subItem, groupIndex, itemIndex)"
                          @delete="removeItem(item, subItem, subItemIndex)"
                          class="sub-item"
                        ></menu-item>
                      </div>
                    </draggable>
                  </template>
                </div>
              </draggable>
            </div>
          </draggable>
        </template>
      </section>
      <section class="menu-list-wrap no-bar">
        <div class="list-title">暂存箱</div>
        <el-input
          v-model="searchText"
          size="small"
          placeholder="页面名称"
          clearable
          prefix-icon="el-icon-search"
          style="margin-bottom: 6px;"
          @input="search"
        ></el-input>
        <draggable group="ungroup" :animation="100" :disabled="true">
          <div v-for="kind in unGroupKinds" :key="kind" class="group-box">
            <menu-item
              type="ungrouped"
              collapsed
              :deletable="false"
              :data="{ name: unGroupMap[kind] }"
              @collapse="collapseUnGroup(kind)"
              :fold="unGroupFold[kind]"
            ></menu-item>
            <draggable
              v-if="!unGroupFold[kind]"
              :sort="false"
              :group="{ name: 'group-item', put: false }"
              v-model="filterUngrouped[kind]"
              :animation="100"
            >
              <menu-item
                v-for="(item, index) in filterUngrouped[kind]"
                type="item"
                :key="item.id"
                :data="item"
                :editable="item.type === 'URL'"
                :deletable="item.type === 'URL'"
                from="unGroup"
                @delete="removeUnGroupItem(item, index)"
                @editUrl="editUrl('unGroup', item)"
                style="padding-left: 24px"
              ></menu-item>
            </draggable>
          </div>
        </draggable>
      </section>
    </section>
    <add-url-dialog ref="addUrl" @submit="addUrl"></add-url-dialog>
    <add-group-dialog ref="addGroup" @submit="addGroup" :group-type="groupType"></add-group-dialog>
    <add-board-dialog ref="addBoard" :app-id="appId" @submit="addBoard"></add-board-dialog>
    <add-sheet-dialog ref="addSheet" :app-id="appId" @submit="addSheet"></add-sheet-dialog>
  </div>
</template>

<script>
import MenuItem from "./MenuItem"
import BaseButton from "@/components/UIComponents/Button"
import draggable from "vuedraggable"
import { randomString, stringIncludes } from "@/utils/common"
import { loadingService } from "@/utils/ui"
import { getSheetGroup, updateSheetGroups } from "@/api/sheet/sheet"
import {
  todoGroup,
  operations,
  unGroupMap,
  unGroupKinds
} from "@/views/Backend/Admin/Display/Menu/static"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import AddUrlDialog from "@/views/Backend/Admin/Display/Menu/AddUrlDialog"
import AddGroupDialog from "@/views/Backend/Admin/Display/Menu/AddGroupDialog"
import AddBoardDialog from "@/views/Backend/Admin/Display/Menu/AddBoardDialog"
import AddSheetDialog from "@/views/Backend/Admin/Display/Menu/AddSheetDialog"

export default {
  name: "backend-display-menu",
  inject: ["app"],
  components: {
    AddSheetDialog,
    AddBoardDialog,
    AddGroupDialog,
    AddUrlDialog,
    DropdownMenu,
    MenuItem,
    BaseButton,
    draggable
  },
  data() {
    return {
      todoGroup,
      operations,
      unGroupMap,
      unGroupKinds,
      showMenuList: false,
      id: "",
      group: [],
      ungrouped: {
        SHEET: [],
        DASHBOARD: [],
        URL: []
      },
      todoVisible: true,
      todoFold: false,
      fold: {},
      unGroupFold: {
        SHEET: false,
        DASHBOARD: true,
        URL: true
      },
      searchText: "",
      filterUngrouped: {
        SHEET: [],
        DASHBOARD: [],
        URL: []
      },
      from: "",
      curGroupIndex: "",
      curSubgroupIndex: "",
      otherItems: [],
      subGroups: [],
      groupType: "",
      moving: {}
    }
  },
  computed: {
    appId() {
      return this.app?.id
    }
  },
  created() {
    this.getSheetGroup()
  },
  methods: {
    // 获取工作表分组列表
    getSheetGroup() {
      return getSheetGroup(this.appId).then(res => {
        let { groups, ungrouped, otherItems, subGroups, id } = res
        this.otherItems = otherItems
        this.subGroups = subGroups
        this.id = id
        this.todoVisible = res.todoVisible
        this.group = groups.map((group, index) => {
          if (!group.id) group.id = randomString(10)
          index === 0 ? this.$set(this.fold, group.id, false) : this.$set(this.fold, group.id, true)
          group.itemList = group.itemList.map(item => {
            if (item.type === "GROUP") {
              this.$set(this.fold, item.id, true)
              item.itemList = item.itemList.map(subItem => {
                subItem.icon = subItem.icon ? subItem.icon : "default-icon"
                subItem.color = subItem.color ? subItem.color : "#1989FA"
                return subItem
              })
            }
            item.icon = item.icon ? item.icon : "default-icon"
            item.color = item.color ? item.color : "#1989FA"
            return item
          })
          return group
        })
        if (!this._.isEmpty(ungrouped)) {
          this.ungrouped = this._.groupBy(
            ungrouped.map(item => {
              item.icon = item.icon ? item.icon : "default-icon"
              item.color = item.color ? item.color : "#1989FA"
              return item
            }),
            "type"
          )
          if (!this._.keys(this.ungrouped).includes("SHEET")) {
            this.ungrouped.SHEET = []
          }
          if (!this._.keys(this.ungrouped).includes("DASHBOARD")) {
            this.ungrouped.DASHBOARD = []
          }
          if (!this._.keys(this.ungrouped).includes("URL")) {
            this.ungrouped.URL = []
          }
        }
        this.filterUngrouped = this._.cloneDeep(this.ungrouped)
        this.showMenuList = true
      })
    },
    // 添加分组
    addGroup(group) {
      if (this.groupType === "group")
        this.group.push({
          id: randomString(10),
          name: group.name,
          itemList: []
        })
      else {
        let subGroup = {
          id: randomString(10),
          name: group.name,
          itemList: [],
          type: "GROUP"
        }
        this.subGroups.push(subGroup)
        this.group[this.curGroupIndex].itemList.push(subGroup)
      }
    },
    // 添加工作表
    addSheet(sheet) {
      this.ungrouped["SHEET"].push(sheet)
      this.filterUngrouped = this._.cloneDeep(this.ungrouped)
    },
    // 添加看板
    addBoard(board) {
      this.ungrouped["DASHBOARD"].push(board)
      this.filterUngrouped = this._.cloneDeep(this.ungrouped)
    },
    // 添加链接
    addUrl(url) {
      if (url.id) {
        let otherIndex = this.otherItems.findIndex(u => u.id === url.id)
        this.otherItems.splice(otherIndex, 1, url)
        if (this.from === "group") {
          let index = this.group[this.curGroupIndex].itemList.findIndex(u => u.id === url.id)
          this.group[this.curGroupIndex].itemList.splice(index, 1, url)
        } else if (this.from === "subGroup") {
          let index = this.group[this.curGroupIndex].itemList[
            this.curSubgroupIndex
          ].itemList.findIndex(u => u.id === url.id)
          this.group[this.curGroupIndex].itemList[this.curSubgroupIndex].itemList.splice(
            index,
            1,
            url
          )
        } else {
          let index = this.ungrouped["URL"].findIndex(u => u.id === url.id)
          this.ungrouped["URL"].splice(index, 1, url)
        }
      } else {
        url.id = randomString(10)
        this.otherItems.push(url)
        this.ungrouped["URL"].push(url)
      }
      this.filterUngrouped = this._.cloneDeep(this.ungrouped)
    },
    // 将页面从分组中移出
    removeItem(group, item, sheetIndex) {
      if (item.type !== "GROUP") {
        group.itemList.splice(sheetIndex, 1)
        this.ungrouped[item.type] = this.ungrouped[item.type].filter(t => t.id !== item.id)
        this.ungrouped[item.type].push(item)
        this.filterUngrouped = this._.cloneDeep(this.ungrouped)
      } else {
        if (item.itemList.length > 0) return this.$message.error("分组内还存在工作表时不可删除！")
        group.itemList.splice(sheetIndex, 1)
        let otherIndex = this.subGroups.findIndex(t => t.id === item.id)
        this.subGroups.splice(otherIndex, 1)
      }
    },
    // 删除链接
    removeUnGroupItem(item, index) {
      let otherIndex = this.otherItems.findIndex(u => u.id === item.id)
      this.otherItems.splice(otherIndex, 1)
      this.ungrouped[item.type].splice(index, 1)
      this.filterUngrouped = this._.cloneDeep(this.ungrouped)
    },
    // 删除分组
    deleteGroup(group, groupIndex) {
      if (group.itemList.length > 0) return this.$message.error("分组内还存在工作表时不可删除！")
      this.group.splice(groupIndex, 1)
    },
    // 校验分组是否存在重名
    verify() {
      let groupNames = this.group.map(i => i.name)
      let unique = new Set(groupNames)
      if (groupNames.length != unique.size) {
        this.$message.error("存在重复的分组名，请修改后再提交！")
        return false
      }
      return true
    },
    // 更新工作表分组
    updateGroup() {
      if (!this.verify()) return
      let loadingInstance = loadingService({ text: "请求中" })
      let groups = this.group.map(group => ({
        id: group.id,
        name: group.name,
        itemIdList: group.itemList.map(item => {
          if (item.type === "GROUP") {
            let index = this.subGroups.findIndex(t => t.id === item.id)
            this.subGroups.splice(index, 1, item)
          }
          return item.id
        })
      }))
      let subGroups = this.subGroups.map(subGroup => ({
        id: subGroup.id,
        name: subGroup.name,
        itemIdList: subGroup.itemList.map(subItem => subItem.id)
      }))
      updateSheetGroups(
        {
          id: this.id,
          groups,
          otherItems: this.otherItems,
          subGroups,
          todoVisible: this.todoVisible
        },
        this.appId
      )
        .then(() => this.$message.success("工作表分组更新成功！"))
        .finally(() => loadingInstance.close())
    },
    changeFold(groupId) {
      if (this.fold[groupId]) {
        this.collapse(groupId)
      }
    },
    collapse(groupId) {
      this.$set(this.fold, groupId, !this.fold[groupId])
    },
    collapseUnGroup(kind) {
      this.$set(this.unGroupFold, kind, !this.unGroupFold[kind])
    },
    search() {
      this.filterUngrouped.SHEET = this.ungrouped.SHEET.filter(i =>
        stringIncludes(i.name, this.searchText)
      )
      this.filterUngrouped.DASHBOARD = this.ungrouped.DASHBOARD.filter(i =>
        stringIncludes(i.name, this.searchText)
      )
      this.filterUngrouped.URL = this.ungrouped.URL.filter(i =>
        stringIncludes(i.name, this.searchText)
      )
    },
    // 待办
    collapseTodo() {
      this.todoFold = !this.todoFold
    },
    hideTodo(data) {
      this.todoVisible = data
    },
    addSubGroup(fatherGroupIndex) {
      this.groupType = "subGroup"
      this.curGroupIndex = fatherGroupIndex
      this.$refs.addGroup.open()
    },
    clickBtn(operation) {
      switch (operation) {
        case "group":
          this.groupType = "group"
          this.$refs.addGroup.open()
          break
        case "sheet":
          this.$refs.addSheet.open()
          break
        case "board":
          this.$refs.addBoard.open()
          break
        case "link":
          this.$refs.addUrl.open()
          break
      }
    },
    editUrl(from, item, groupIndex, subGroupIndex) {
      this.from = from
      if (this.from === "group") this.curGroupIndex = groupIndex
      if (this.from === "subGroup") {
        this.curGroupIndex = groupIndex
        this.curSubgroupIndex = subGroupIndex
      }
      this.$refs.addUrl.open(item)
    },
    start(e, group) {
      this.moving = group.itemList[e.oldIndex]
    },
    getPut(to, from) {
      let isSameGroup = from.options.group.name === to.options.group.name
      return isSameGroup && this.moving.type !== "GROUP"
    }
  }
}
</script>

<style lang="scss" scoped>
.display-menu {
  .empty {
    height: calc(100vh - 52px - 60px);
    width: 100%;
  }
  .save {
    margin-left: 10px;
  }
  .content-box {
    display: flex;
    .group-empty {
      text-align: center;
      height: 80px;
      line-height: 80px;
      color: #757575;
      font-size: 13px;
    }
    .menu-list-wrap {
      padding: 20px 30px 20px 16px;
      height: calc(100vh - 52px - 60px);
      width: 50%;
      max-width: 700px;
      overflow: auto;
      box-sizing: border-box;
      .list-title {
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .group-box {
        border-bottom: 1px solid #fff;
      }
    }
    .sheet-row {
      padding-left: 33px;
    }
    .sub-group {
      padding-left: 40px;
      background-color: #eee;
    }
    .sub-item {
      padding-left: 26px;
    }
  }
}
</style>
